<i class="fa fa-spinner fa-spin loading" *ngIf="this.state === Types.LOADING"></i>
<i class="fa fa-check ok" *ngIf="this.state === Types.OK"></i>
<i class="fa fa-times error" *ngIf="this.state === Types.ERROR"></i>
